import { PortalEventStats } from "./entity";
import DtoList from "../../base_classes/dto_list";
import { type JSONData } from "../../base_classes/dto.d";
import { type IPortalEventStatsList } from "./list.gen.d";
import { Pagination } from "../../base_classes/pagination";
import { Query } from "../../base_classes/query";

/// ///////////////////////////////////////////////////////////////////////////////////////////////////
/// WARNING! THIS FILE IS AUTOMATICALLY GENERATED, ANY CHANGES WILL BE LOST ON NEXT GENERATION
/// ///////////////////////////////////////////////////////////////////////////////////////////////////

export class PortalEventStatsList
  extends DtoList
  implements IPortalEventStatsList
{
  /// ///////////////////////////////////////
  /// //////// PRIVATE VARIABLES ////////////
  /// ///////////////////////////////////////
  _path = "/portal_event_stats";

  /// ///////////////////////////////////////
  /// ///////// PUBLIC VARIABLES ////////////
  /// ///////////////////////////////////////
  list: PortalEventStats[] = [];
  queriedList: PortalEventStats[] = [];

  /// ///////////////////////////////////////
  /// ////////////// METHODS ////////////////
  /// ///////////////////////////////////////

  _buildInstance(data: JSONData): PortalEventStats {
    return new PortalEventStats([], data);
  }

  override async getAll(
    pathVars?: string | string[] | Record<string, string>,
  ): Promise<PortalEventStats[]> {
    return (await super.getAll(pathVars)) as PortalEventStats[];
  }

  override async getPaginated(
    pathVars: string | string[],
    pagination: Pagination,
  ): Promise<{
    items: PortalEventStats[];
    pagination: Pagination;
  }> {
    // eslint-disable-next-line @typescript-eslint/no-unsafe-argument
    return (await super.getPaginated(pathVars, pagination)) as {
      items: PortalEventStats[];
      pagination: Pagination;
    };
  }

  override async query(
    queries: Query[],
    pagination?: Pagination,
  ): Promise<{
    items: PortalEventStats[];
    pagination: Pagination;
  }> {
    return (await super.query(queries, pagination)) as {
      items: PortalEventStats[];
      pagination: Pagination;
    };
  }

  override async search(
    query: string,
    pagination?: Pagination,
  ): Promise<{
    items: PortalEventStats[];
    pagination: Pagination;
  }> {
    return (await super.search(query, pagination)) as {
      items: PortalEventStats[];
      pagination: Pagination;
    };
  }
}
